module.exports = __webpack_public_path__ + "media/Loops Vocals.0bfb065a.wav";